import React from "react";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import notFoundImage from "../assets/img/pageNotFound.JPG";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
  },
  image: {
    height: "100%",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
  },
}));

const PageNotFound = () => {
  const classes = useStyles();

  return (
    <Grid container component="main" className={classes.root}>
      <Grid item style={{ alignSelf: "center" }} className={classes.image}>
        <img height={"100%"} src={notFoundImage} />
      </Grid>
    </Grid>
  );
};

export default PageNotFound;
